module.exports = __webpack_public_path__ + "img/cm_s2-slc1-a.03e3995c.png";